import { observer } from 'mobx-react-lite'
import { Link } from 'react-router-dom'
import { Box, Icon, Typography } from 'shared/ui'
import { LINK_WEBSITE } from 'shared/constants/links'
import { useReviewViewContext } from 'pages/reviews/context'
import styles from './styles.module.scss'

export const PreviewFooter = observer(() => {
  const { bgColor } = useReviewViewContext()

  return (
    <Box
      className={styles.footer}
      sx={{ background: `linear-gradient(180deg, transparent 0%, ${bgColor} 75%)` }}
    >
      <Link to={LINK_WEBSITE} className={styles.footerLink} target={'_blank'}>
        <Icon icon='logoOld' color='#1D95F2' fontSize={14} />
        <Typography ariaLabel={'title'} variant={'body-sm-regular'}>
          Powered by Salesmsg
        </Typography>
      </Link>
    </Box>
  )
})
